/** Strip vendor/API leaks from assistant replies — always show reDevicer AI branding. */
export function sanitizeAiReply(text: string, fallback: string): string {
  const trimmed = text.trim()
  if (!trimmed) return fallback

  const lower = trimmed.toLowerCase()
  const leaked =
    lower.includes('openai') ||
    lower.includes('open_ai') ||
    trimmed.includes('OPENAI_API_KEY') ||
    lower.includes('api_key') ||
    lower.includes('nesukonfigūruotas serveryje') ||
    lower.includes("hasn't configured the key") ||
    lower.includes('administratorius dar nesukonfigūravo') ||
    lower.includes('admin has not configured')

  return leaked ? fallback : trimmed
}

export function sanitizeAiHistory<T extends { role: string; content: string }>(
  messages: T[],
  fallback: string,
): T[] {
  return messages.map((m) =>
    m.role === 'assistant'
      ? { ...m, content: sanitizeAiReply(m.content, fallback) }
      : m,
  )
}
